/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';

const state = {
  isLoading: false,
  currentUser: null,
};

const getters = {
  isLoading: state => state.isLoading,
  currentUser: state => state.currentUser,
};

const mutations = {
  setIsCurrentUserLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setCurrentUser(state, currentUser) {
    state.currentUser = _.cloneDeep(currentUser);
  },
  destoryCurrentUser(state) {
    state.currentUser = null;
  },
};

const actions = {
  setCurrentUser({ commit }, currentUser) {
    commit('setCurrentUser', currentUser);
  },
  destoryCurrentUser({ commit }) {
    commit('destoryCurrentUser');
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
